<script setup lang="ts">
    // @ts-ignore
    import i18n from '@/localization/i18n';
    import useNavigationStore from '@/stores/ui/navigation'

    import {onBeforeUnmount, onMounted} from "vue";
    import { usePageContext } from 'vike-vue/usePageContext'
    import { navigate } from 'vike/client/router'

    import { defineAsyncComponent } from 'vue';
    import { updateorAddMetaTag } from '@/utils/functions';

    const Default = defineAsyncComponent(() => import('@/views/layouts/Default.vue'));

    const VITE_ASSET_URL = import.meta.env.VITE_ASSET_URL

    const pageContext = usePageContext()

    const t = i18n.global.t
    const navigationStore = useNavigationStore()

    const scrollToSection = async (id: string) => {
        if (pageContext.urlPathname !== '/') {
            navigationStore.setHomeScrollTo(id)
            await navigate('/')
        } else {
            const section = document.getElementById(id)

            if (section) {
                section.scrollIntoView({
                    behavior: "smooth"
                })
            }
        }
    };

    let metaTag: any;
    onMounted(() => {
        metaTag = document.createElement("meta");
        metaTag.name = "robots";
        metaTag.content = "index, follow";
        document.head.appendChild(metaTag);

        document.querySelector('link[rel="canonical"]')?.setAttribute('href', document.location.href);
        updateorAddMetaTag('description', '');
        if (typeof window !== 'undefined') {
            window.scrollTo(0, 0)
        }
    })

    onBeforeUnmount(() => {
        if (metaTag && document.head.contains(metaTag)) {
            document.head.removeChild(metaTag);
        }
    })
</script>

<template>
    <Default>
        <!-- BEGIN: Content-->
        <div class="app-content content bg-white pt-5" style="min-height: 73vh; margin-left: 0px"> 
            <div class="content-wrapper container-fluid bg-white h-100 pt-0 pt-md-5">
                <main id="main">
                    <!-- ======= Blog Section ======= -->
                    <section id="blog" class="blogmt-0 mb-0 pt-0 pt-md-5">
                        <div class="container aos-init aos-animate" data-aos="fade-up">
                            <div class="row">

                                <div class="col-lg-12">
                                    <h1 class="text-center mb-5">
                                        {{ 'Qui sommes-nous ?​' }}
                                    </h1>
                                    <div class="row">
                                        <div class="col-md-6 pe-md-4">
                                            <p class="text-dark">
                                                Nous sommes créateurs de plateformes digitales. 
                                                Passionnés de savoir-faire, nous avons une grande 
                                                considération pour ceux qui, comme nous, entreprennent chaque jour.
                                            </p>
                                            <p class="text-dark">
                                                Notre projet est né de notre envie d’apporter aux 
                                                entrepreneurs un outil accessible, 
                                                utilisable partout, qui simplifie leur quotidien administratif.​
                                            </p>
                                            <p class="text-dark">
                                                C’est ainsi que nous avons réalisé <strong>topela</strong>, la première plateforme 
                                                à offrir une <strong>solution entièrement mobile</strong> pour professionnels et une <strong>interaction client temps réel</strong>.​
                                            </p>
                                            <p class="text-dark">
                                                <strong>Notre souhait : vous offrir toujours plus de services utiles et agréables !​</strong><br>
                                                Nous restons constamment à votre écoute pour mettre en œuvre de nouvelles 
                                                idées et pour faire de topela la solution qui facilite vos relations d’affaire.​
                                            </p>
                                        </div>
                                        <div class="col-md-6 ps-md-4 pt-">
                                            <div class="row gy-4 gy-md-0">
                                                <div class="col-md-4 text-center text-md-start">
                                                    <img :src="VITE_ASSET_URL + 'assets/public/assets/img/team/Esther.webp'" alt="Esther COUR">
                                                    <div class="mt-2">
                                                        <div class="h-style h5-style use-poppins text-info fw-bold">Esther COUR</div>
                                                        <div class="h-style-with-color h6-style use-poppins">Dirigeante</div>
                                                        <div class="h-style-with-color h6-style use-poppins">Fondatrice</div>
                                                    </div>
                                                </div>
                                                <div class="col-md-4 text-center text-md-start">
                                                    <img :src="VITE_ASSET_URL + 'assets/public/assets/img/team/Louis.webp'" alt="Louis KICH">
                                                    <div class="mt-2">
                                                        <div class="h-style h5-style use-poppins text-info fw-bold">Louis KICH</div>
                                                        <div class="h-style-with-color h6-style use-poppins">Directeur Commercial</div>
                                                        <div class="h-style-with-color h6-style use-poppins">Fondateur</div>
                                                    </div>
                                                </div>
                                                <div class="col-md-4 text-center text-md-start">
                                                    <img :src="VITE_ASSET_URL + 'assets/public/assets/img/team/Felix.webp'" alt="Félix SAGNO">
                                                    <div class="mt-2">
                                                        <div class="h-style h5-style use-poppins text-info fw-bold">Félix SAGNO</div>
                                                        <div class="h-style-with-color h6-style use-poppins">Directeur</div>
                                                        <div class="h-style-with-color h6-style use-poppins">Technique</div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="col-lg-12 mt-5">
                                    <h4 class="text-dark text-center">Ils nous soutiennent, nous les en remercions !​</h4>
                                     <div class="col-lg-12 mt-5">
          <div class="d-flex justify-content-center flex-wrap align-items-center gap-4 partners-logos">

            <img class="partner-logo"
              :src="VITE_ASSET_URL + 'assets/public/assets/img/partners/reseau entreprendre.webp'"
              alt="Réseau Entreprendre" />

            <img class="partner-logo" :src="VITE_ASSET_URL + 'assets/public/assets/img/partners/MDE_vallee_sud.webp'"
              alt="MDE Vallée Sud" />

            <img class="partner-logo" :src="VITE_ASSET_URL + 'assets/public/assets/img/partners/CCI.webp'" alt="CCI" />

            <img class="partner-logo" :src="VITE_ASSET_URL + 'assets/public/assets/img/partners/Logo_Plessis.webp'"
              alt="Le Plessis" />
            <a href="https://www.pennylane.com/fr/integrations/topela" target="_blank">
              <img class="partner-logo" :src="VITE_ASSET_URL + 'assets/public/assets/img/partners/Logo_Pennylane.webp'"
                alt="Pennylane" />
            </a>
            <a href="https://www.leroymerlin.fr/" target="_blank">
              <img class="partner-logo" :src="VITE_ASSET_URL + 'assets/public/assets/img/partners/logo_lm_massy.webp'"
                alt="Leroy Merlin Massy" />
            </a>
          </div>
        </div>
                                </div>

                            </div>

                        </div>
                    </section>
                    <!-- End Blog Section -->
                </main>
            </div>
        </div>
    </Default>
</template>

<style scoped>
p {
    color: rgb(75, 75, 75);
    margin-top: 0;
    margin-bottom: 0.5rem !important;
}
.partner-logo {
  height: 150px;
  filter: grayscale(100%);
  opacity: 0.7;
  transition: filter 0.3s ease, opacity 0.3s ease, transform 0.3s ease;
}

/* Hover desktop */
.partner-logo:hover {
  filter: grayscale(0%);
  opacity: 1;
  transform: scale(1.05);
}

/* Mobile : logos plus petits */
@media (max-width: 768px) {
  .partner-logo {
    height: 75px;
  }
}
</style>